var WorkViewModal = (function (base) {
  __extends(WorkViewModal, base);

  function WorkViewModal(apiClient) {
    const self = base.call(this, apiClient) || this;
    return self;
  };

    function getUrl(workId) {
        return 'api/works/{0}'.format(workId);
    }

  WorkViewModal.prototype.activate = function (workId, deleteFunc, refreshFunc) {
    const self = this;

      this.loadContent(getUrl(workId))
      .then($modal => {

        $('li.select2-selection__choice', $modal).each(function (idx, li) {
          const option = Select2Helper().findOption($(this));
          $(this).attr('class', 'select2-selection__choice ' + option.attr('class'));
        });

        $modal

          // Редактирование
          .on('click', '[js=edit]', function () {
            $('#transportLocationReportEdit').html('');

            ModalConductor.activate(WorkEditModal, workId)
                .on('closed', (modalResult) => {

                    function afterSave(modalResult, workId) {
                        if (modalResult.data.canAutoUpdate) {
                            var status = modalResult.data.status;
                            workId = modalResult.data.id ? modalResult.data.id : workId;
                            ModalConductor.activate(WorkAutoStatusModal, workId, status).on('closed',
                                (modalResult) => {
                                    self.reloadContent(getUrl(workId));
                                });
                        } else {
                            self.reloadContent(getUrl(workId));
                        }
                    }
                  self.reloadContent(getUrl(workId));

                if (modalResult.ok) {
                  if (refreshFunc) {
                    refreshFunc();
                    }
                    if (modalResult.data.boundaryChanged) {
                        ModalConductor.activate(MessageModal, $('#message-tmpl').text(), 'Внимание!', 'Границы Работы сопоставлены с Участком обслуживания')
                            .on('closed',
                                (mr) => {
                                    afterSave(modalResult, workId);
                                });
                    } else {
                        afterSave(modalResult, workId);
                    }
                }

                $('li.select2-selection__choice', $modal).each(function (idx, li) {
                  const option = Select2Helper().findOption($(this));
                  $(this).attr('class', 'select2-selection__choice ' + option.attr('class'));
                });
              });
          })

          // Копирование
          .on('click', '[js=copy]', function () {
            $('#transportLocationReport').html('');
            $('#transportLocationReportEdit').html('');

            ModalConductor.activate(WorkEditModal, workId, true)
              .on('closed', (modalResult) => {
                if (modalResult.ok) {
                  refreshFunc();
                  workId = modalResult.data.id ? modalResult.data.id : workId;
                  if (modalResult.data.canAutoUpdate) {
                    var status = modalResult.data.status;
                    ModalConductor.activate(WorkAutoStatusModal, workId, status).on('closed', (modalResult) => {
                        self.reloadContent(getUrl(workId));
                    });
                  } else {
                      self.reloadContent(getUrl(workId));
                  }
                }

                $('li.select2-selection__choice', $modal).each(function (idx, li) {
                  const option = Select2Helper().findOption($(this));
                  $(this).attr('class', 'select2-selection__choice ' + option.attr('class'));
                });
              });
          })

          // Удаление
          .on('click', '[js=delete]', function (e) {
                if ($(this).attr('disabled')) {
                    e.preventDefault();
                } else {
                    if (confirm('Вы действительно хотите удалить эту работу?')) {
                        deleteFunc(workId);
                    }
                }
            })

          // Добавление комментария
          .on('click', '.note-add', function () {
            const noteText = $('#Note', $modal).val();
            _addNote.call(self, workId, noteText)
              .then(() => {
                  self.reloadContent(getUrl(workId));
              });
          })

          // Удаление комментария
          .on('click', '.note-delete', function () {
            const noteId = $(this).data('id');
            if (confirm('Вы действительно хотите удалить этот комментарий?')) {
              _deleteNote.call(self, workId, noteId)
                .then(() => {
                    self.reloadContent(getUrl(workId));
                });
            }
          })

          // Кнопка рассчета трека
          .on('click', '#calc-track', function () {
            var $control = $(this);
            $control.attr('disabled', 'disabled');
            $control.val('Подождите...').text('Подождите').removeClass('btn-primary').addClass('btn-danger');
            $('#modal-spinner').removeAttr('style');
            $('#date-conteiner').addClass('busy');

              self.apiClient.post('api/works/track', { ids: workId })
              .then(trackReportIds=> {
                if (trackReportIds) {
                  window.globalReportsId.CoverageReport = trackReportIds;
                  window.globalReportsId.ObjId = workId;
                  localStorage.setItem('globalReportsId', JSON.stringify(window.globalReportsId));
                }
              })
              .catch(() => {
                $control.removeAttr('disabled');
                $control.val('Ошибка!').text('Рассчитать').addClass('btn-primary').removeClass('btn-danger');
                $('#date-conteiner').removeClass('busy');
              });
          });
      });
  };

  function _deleteNote(workId, noteId) {
    return this.apiClient.delete('api/works/{0}/notes'.format(workId), { noteId: noteId });
  }

  function _addNote(workId, text) {
    return this.apiClient.put('api/works/{0}/notes'.format(workId), { text: text });
  };

  return WorkViewModal;
}(BaseModal));
